import React from 'react';
import { Layout, Row, Col } from 'antd';
import { withRouter } from 'react-router-dom';

import BadgeIos from '../../resources/img/badge_ios.svg';
import Logo from '../../resources/img/cubefit_title.png';
import CubeFitBack from '../../resources/img/cubefit.png';
import CubeFitAnim from '../../resources/img/cubefit_animated.gif';
import Left from '../../resources/img/left.png';
import Button from '../components/Button';
import Footer from '../components/Footer';

const { Header, Content } = Layout;


class CubeFit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        }
    }

    render() {
        return (
            <Layout className={'fadeIn full-layout cube-fit'}>
                <Header className={'header cube-fit__header'}>
                    <div className={'cube-fit__logo'}>
                        <Button icon={Left} className={'cube-fit__back'} onClick={() => this.props.history.push('/')}/>
                        <img className={'cube-fit__logo__img'} src={Logo} alt="logo"/>
                    </div>
                </Header>
                <Content className={'cube-fit__content-box'}>
                    <div className={'cube-fit__background-anim'}>
                        <img className={'cube-fit__background-anim__img'} src={CubeFitAnim} alt="Cube Fit"/>
                    </div>
                    {/*<div className={'cube-fit__content'}>*/}
                        {/*<img className={'cube-fit__background'} src={CubeFitBack} alt="Cube Fit"/>*/}
                    {/*</div>*/}
                    <div className={'cube-fit__content cube-fit__content--center'}>
                        <Row justify={'center'} align={'middle'}>
                            <Col lg={7} sm={8} xs={24}>
                                <div className={'cube-fit__download-box'}>
                                    <a target={'blank'} href="https://apps.apple.com/us/app/cube-fit-swipe-roll/id1521303073?mt=8">
                                        <img className={'cube-fit__download-icon cube-fit__download-icon--ios'} alt='Download on the App Store' src={BadgeIos}/>
                                    </a>
                                </div>
                            </Col>
                            <Col lg={7} sm={8} xs={24}>
                                <div className={'cube-fit__download-box'}>
                                    <a target={'blank'} href='https://play.google.com/store/apps/details?id=com.Dev09.CubeFit&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                                        <img className={'cube-fit__download-icon'} alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
                                    </a>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Content>
                <Footer/>
            </Layout>
        );
    }
}

export default withRouter(CubeFit);